import * as dashboardsApi from "@hub/settings/src/modules/dashboards/api/dashboards.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const listDashboards = async params => {
  try {
    return await dashboardsApi.listDashboards(params)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
  }
}

export const fetchDashboard = async uuid => {
  try {
    const { data } = await dashboardsApi.fetchDashboard(uuid)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
  }
}

export const createDashboard = async payload => {
  try {
    const { data } = await dashboardsApi.createDashboard(payload)
    window.$vue.$toast({
      type: "success",
      title: "Dashboard criado com sucesso."
    })
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
  }
}

export const updateDashboard = async (uuid, payload) => {
  try {
    const { data } = await dashboardsApi.updateDashboard(uuid, payload)
    window.$vue.$toast({
      type: "success",
      title: "Dashboard atualizado com sucesso."
    })
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
  }
}

export const changeDashboardStatus = async (uuid, payload) => {
  try {
    const { data } = await dashboardsApi.changeDashboardStatus(uuid, payload)
    window.$vue.$toast({
      type: "success",
      title: "Status alterado com sucesso."
    })
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
  }
}
